import useHead, {
  localBusinessLd,
  websiteLd,
  breadcrumbLd,
  faqLd,
  offerCatalogLd,
} from "@/components/seo/useHead";

/**
 * Head-manager component. Injects title, description, canonical,
 * OG/Twitter tags, and optional JSON-LD via a small custom hook that
 * works reliably with React 19.
 */
export default function Seo(props) {
  useHead(props);
  return null;
}

export { localBusinessLd, websiteLd, breadcrumbLd, faqLd, offerCatalogLd };
